import { useQuery } from '@tanstack/react-query';
import { commonService } from '../services/common/common.service';
import { AutoFillParams, AutoFillResponse } from '../services/common/common.types';

interface UseAutoFillQueryProps extends AutoFillParams {
  enabled?: boolean;
  nodeId?: string;
}

export const useAutoFillQuery = ({
  baseName,
  tableName,
  type,
  enabled = true,
  nodeId,
}: UseAutoFillQueryProps) => {
  return useQuery<AutoFillResponse>({
    queryKey: ['auto-fill', nodeId ?? '__global__', baseName, tableName],

    queryFn: async () => {
      return commonService.autoFill({
        baseName,
        tableName,
        type,
      });
    },

    enabled: enabled && !!baseName && !!tableName,

    staleTime: Infinity,
    gcTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    retry: false,
  });
};
